import {Constants} from '../../../constants';
import {HeatCycleIndex} from './PeakDevice/UnitCycleAccess';
import {HeatCycleTarget, Target} from './PeakDevice/UnitLedApi';
import {
  TEMP_HEAT_CYCLE_ARRAY_INDEX,
  isNvmIndex,
  isTempHeatProfileIndex,
} from './pikaparam';

export const getTarget = (index: HeatCycleIndex) => {
  if (isTempHeatProfileIndex(index)) return 'tempHeatCycle';

  return `heatCycle${index}` as const;
};

export const getHeatCycleIndex = (target: HeatCycleTarget) => {
  if (target === 'tempHeatCycle') return TEMP_HEAT_CYCLE_ARRAY_INDEX;

  return parseInt(target.slice(-1)) as HeatCycleIndex;
};

export const getNvmIndex = (target: Target) => {
  if (target === 'lantern')
    return Constants.NVM_ARRAY_INDICES.DEFAULT_LANTERN_ARRAY_INDEX;

  const addend = getHeatCycleIndex(target);

  const value = Constants.NVM_ARRAY_INDICES.HEAT_PROFILE_0 + addend;

  if (!isNvmIndex(value))
    throw new Error(`Nvm indices operation result is a non-nvm index`);

  return value;
};
